import { render } from "./App.vue?vue&type=template&id=b1dafb54"
const script = {}

import "./App.vue?vue&type=style&index=0&id=b1dafb54&lang=scss"

import exportComponent from "/home/runner/work/democratielab-poster/democratielab-poster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__